import cn from 'classnames';
import { formatMoney } from '@shopify/theme-currency';
import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartTotals = ({ className }) => {
  const {
    cart: { total_price },
  } = useCartContext();

  return (
    <div class={cn('flex justify-between', className)}>
      <p class="text-stone">{getTranslation('cart.subtotal')}</p>
      <p>{formatMoney(total_price, theme.moneyWithCurrencyFormat)}</p>
    </div>
  );
};

export default CartTotals;
